import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.some.js";
import KNB from '@dp/knb';
import UA from '../ua/index';
import Geo from '../geo/index';
export default function getMaoyanPermission(persmissionData) {
  return new Promise(function (resolve, reject) {
    var version = (UA.appVersion || '').split('.').slice(0, 3).join('.');
    if (!(UA.IS_MAOYAN && UA.osName === 'android' && KNB.Semver.gte(version, '9.52.0'))) {
      resolve(true);
      return;
    }
    KNB.use('movie.scenePermission', {
      data: persmissionData,
      success: function success(res) {
        if (res.status === 'success' && Array.isArray(res.data) && res.data.every(function (a) {
          return a.granted;
        })) {
          if (persmissionData.some(function (p) {
            return p.permission === 'permission_location';
          })) {
            Geo.fetchLocation().catch().then(function () {
              resolve(true);
            }).catch(function (err) {
              console.warn(err);
            });
          } else {
            resolve(true);
          }
        } else {
          resolve(false);
        }
      },
      fail: function fail(e) {
        resolve(false);
      }
    });
  });
}